import { ReactNode } from 'react'
import { Box, BoxProps, Stack, Typography } from '@mui/material'

export interface AuroraControlGroupProps extends BoxProps {
  label: ReactNode
  icon?: ReactNode
  direction?: 'row' | 'column'
  gap?: number
}

export default function AuroraControlGroup({
  label,
  icon,
  children,
  direction = 'column',
  gap = 2,
  ...props
}: AuroraControlGroupProps) {
  return (
    <Box {...props}>
      {/*<Stack direction="row" alignItems="center" gap={2} sx={{ mb: 4 }}>
        {icon}
        <Typography variant="h6">{label}</Typography>
      </Stack>*/}

      <Stack direction={direction} gap={gap}>
        {children}
      </Stack>
    </Box>
  )
}
